import angular = require('angular');
import { BackToDashboardService } from '../../services/back-to-dashboard.service';

export class BackToDashboardComponent {
  public static $inject = ['backToDashboardService'];
  public fixed: boolean;

  constructor(private backToDashboardService: BackToDashboardService) {
  }

  public canNavigateBack(): boolean {
    return !!this.backToDashboardService.dashboardLink;
  }

  public goBackLink() {
    window.location.href = this.backToDashboardService.dashboardLink;
  }
}

angular.module('app.common').component('backToDashboard', {
  template: require('./back-to-dashboard.component.html'),
  controller: BackToDashboardComponent,
  controllerAs: 'ctrl',
  bindings: {
    fixed: '<'
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/back-to-dashboard/back-to-dashboard.component.ts